import React from 'react';

import DatePicker from 'react-flatpickr';
import TextInput from '../../../Form/TextInput';
import CurrencyInput from '../../../Form/CurrencyInput';
import PercentageInput from '../../../Form/PercentageInput';
import Select from '../../../Form/Select';

export default function Input({ value, setValue, type }) {
  let currentType = type;

  if (typeof type === 'object' && type !== null) {
    currentType = type.type;
  }

  switch (currentType) {
    case 'currency':
      return (
        <CurrencyInput
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
          }}
        />
      );
    case 'date':
      return (
        <DatePicker
          value={value}
          onChange={(date) => {
            setValue(date);
          }}
        />
      );
    case 'percentage':
      return (
        <PercentageInput
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
          }}
        />
      );
    case 'select':
      return (
        <Select
          value={value}
          setFieldValue={(_, val) => {
            setValue(val);
          }}
          options={type.options}
        />
      );
    default:
      return (
        <TextInput
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
          }}
        />
      );
  }
}
